<template>
    <div class="col-lg-4 dashboard__box-col">
        <div :class="['box ', color]">
            <h2 class="h h--2">Nagrody</h2>
            <p v-if="user.is_invoiced">Znajdziesz tu listę zamówionych nagród. Jeśli chcesz wybrać kolejne, odwiedź nasz katalog nagród.</p>
            <p v-else>Dokonaj pierwszej rejestracji faktury aby móc korzystać z naszego katalogu nagród!</p>
            <p><router-link :to="{name: 'MyPrizes'}" class="box__link">&raquo; Zamówione nagrody</router-link></p>
            <router-link :to="{name: 'Prizes'}" class="button button__bottom">
                Zobacz katalog nagród &raquo;
            </router-link>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'PrizesWidget',
        props: {
            color: {
                default: 'box--dark-blue'
            }
        },
        data () {
            return {

            }
        },
        computed: {
            user() {
                return this.$store.state.user
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/app/home/prizes/PrizesWidget.vue